function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.875 18.625C26.875 19.3543 26.5853 20.0538 26.0695 20.5695C25.5538 21.0853 24.8543 21.375 24.125 21.375H7.625L2.125 26.875V4.875C2.125 4.14565 2.41473 3.44618 2.93046 2.93046C3.44618 2.41473 4.14565 2.125 4.875 2.125H24.125C24.8543 2.125 25.5538 2.41473 26.0695 2.93046C26.5853 3.44618 26.875 4.14565 26.875 4.875V18.625Z",
  stroke: "#8A8A8A",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector-1.c264209374b2e34f6ae4f7fac5381978.svg";
export { ForwardRef as ReactComponent };